import { render, staticRenderFns } from "./ComToComPay.vue?vue&type=template&id=d0fc7cd8&scoped=true&"
import script from "./ComToComPay.vue?vue&type=script&lang=js&"
export * from "./ComToComPay.vue?vue&type=script&lang=js&"
import style0 from "./ComToComPay.vue?vue&type=style&index=0&id=d0fc7cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fc7cd8",
  null
  
)

export default component.exports